import React from 'react';
import Cookies from 'js-cookie';
import { Link } from 'react-router-dom';

type Props = {
  title: string;
}

export class Topbar extends React.Component<Props> {
  render() {
    return (
      <div className='top-bar color-scheme-transparent'>
        <button className='btn btn-primary px-2 mx-3 toggle-menu' onClick={ this.toggleMenu }><i className="fal fa-bars fa-lg"></i></button>
        <div className='logo-w menu-size mx-1'>
          <Link className='logo' to='/'>
            <img alt={ (window as any).setting.title } src={ (window as any).setting.logo } style={{ height: "35px" }}/>
            <div className='logo-label'>
              { this.props.title }
            </div>
          </Link>
        </div>
  
        <button className='btn btn-danger mx-3 px-2' title="Logout" onClick={ this.logout }><i className="fal fa-sign-out-alt fa-lg text-white"></i></button>
      </div>
    );
  }

  private toggleMenu = () => {
    document.querySelector(".menu-w")!.classList.toggle("show");
  }

  private logout = () => {
    const result = window.confirm('Do you really want to logout?');
    if(result) {
      Cookies.remove('token');
      window.location.replace("/signin");
    }
  }
} 